import { Autocomplete, FormControl, Grid, IconButton, InputAdornment, InputBase, MenuItem, OutlinedInput, Paper, Select, TextareaAutosize, TextField, Typography } from "@mui/material";
import Modal from "components/ui/Modal";
import dayjs from "dayjs";
import "./createprojectmodal.css";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { ReactComponent as Arrow } from "assets/icons/black_round_arrow.svg";
import CalenderComp from "features/Setting/order/components/CalenderComp";
import Button from "../Button";
import { debounce, upperCase } from "lodash";
import CloseIcon from "@mui/icons-material/Close";
import apiClient from "lib/api-client";
import { useCreateProject } from "./createProjectAPI";
import Popper from "@mui/material/Popper";
import { toast } from "react-toastify";
import { formatDate } from "utils/formatDate";
import CommentComp from "../commentInput/CommentComp";
import AudioPlayer from "../commentSection/audioPlayer/AudioPlayer";
import { ReactComponent as MicIcon } from "assets/icons/Mic.svg";

function CreateProjectDetailsModal({ open, handleClose, designData }) {
  const [openMenu, setOpenMenu] = useState(false);
  const [selected, setSelected] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [formatedSelectedDate, setFormatedSelectedDate] = useState(null);
  const [nickname, setNickname] = useState("");
  const [comment, setComment] = useState("");
  const [saveChange, setSaveChanges] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);
  const [startRecording, setStartRecording] = useState(false);
  const commentRef = useRef(null);
  const [recordedData, setRecordedData] = useState(false);
  const [recordedBlobData, setRecordedBlobData] = useState(null);
  const [showAudioPlayer, setAudioPlayer] = useState(false);
  const onCompleted = () => {
    setNickname("");
    setSelected("");
    setComment("");
    setSelectedDate(null);
    setSaveChanges(false);
    setOpenMenu(false);
    setClientList([]);
    handleClose();
  };

  const { mutate: createProjectAPI } = useCreateProject({ onCompleted });

  const handleMicClick = () => {
    setStartRecording(true);
    setTimeout(() => {
      commentRef.current?.handleMicFunction();
    }, 100);
  };

  useEffect(() => {
    return () => {
      if (recordedData) URL.revokeObjectURL(recordedData);
    };
  }, [recordedData]);

  useEffect(() => {
    if (nickname && selected && selectedDate && comment) {
      setSaveChanges(true);
    } else {
      setSaveChanges(false);
    }
  }, [nickname, selected, selectedDate, comment]);

  const handleNicknameChange = (e) => {
    setNickname(e.target.value);
  };

  const handleCommentSave = (e) => {
    setComment(e.target.value);
  };

  const toggleCalendar = () => setShowCalendar(true);

  const closeCalender = () => {
    setShowCalendar((prev) => !prev);
  };

  const handleDateSelect = (formattedDate) => {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const format = (date) => {
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      return `${String(date.getDate()).padStart(2, "0")} ${months[date.getMonth()]} ${date.getFullYear()}`;
    };

    setSelectedDate(formattedDate);

    // setShowCalendar(false);
  };

  const handleSave = async () => {
    const formattedDate = dayjs(selectedDate).format("MM-DD-YYYY");
    let payload = {
      projectName: nickname,
      comment,
      projectDueDate: formattedDate,
      clientCode: selected?.clientCode,
      ...designData,
    };
    if (saveChange) {
      createProjectAPI(payload);
    } else {
      toast.error("Please fill all details", {
        autoClose: 1000,
        hideProgressBar: false,
      });
    }
  };

  const fetchClientSuggestions = async (query) => {
    try {
      setLoading(true);
      const searchQuery = query === "" ? "a" : query;
      const res = await apiClient.get(`/api/v4/gati_client/getclientList?searchBy=${searchQuery}`);
      const filteredOptions = res?.data?.client?.filter((options) => options?.clientName !== "(As Per Detail)") || [];
      setClientList(filteredOptions);
    } catch (err) {
      console.error("Error fetching client list:", err);
      setClientList([]);
    } finally {
      setLoading(false);
    }
  };
  const clearState = () => {
    setNickname("");
    setSelected("");
    setComment("");
    setSelectedDate(null);
    setSaveChanges(false);
    setOpenMenu(false);
    setClientList([]);
    // Add these lines:
    setStartRecording(false);
    setRecordedData(false);
    setRecordedBlobData(null);
    setAudioPlayer(false);
    handleClose();
  };
  useEffect(() => {
    if (!openMenu && inputRef.current) {
      inputRef.current.blur();
    }
  }, [openMenu]);

  const debouncedFetchClientSuggestions = useMemo(() => debounce(fetchClientSuggestions, 300), []);

  return (
    <Modal open={open} handleClose={clearState} style={{ width: "22.5vw", maxHeight: "100vh", padding: "1.9vw 1.3vw" }}>
      <Grid container spacing={"1.2vw"}>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="main-grid" sx={{ position: "sticky", top: "-20px", zIndex: 1000, backgroundColor: "#fff" }}>
          <Typography className="select-header">Project Details</Typography>
        </Grid>

        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="main-grid-item">
          <Typography className="select-header-create">Nickname</Typography>
          <OutlinedInput
            spellCheck={false}
            autoFocus={false}
            autoComplete="off"
            type="text"
            placeholder="Enter nickname"
            value={nickname}
            className="input-field"
            onChange={(e) => handleNicknameChange(e)}
            endAdornment={
              nickname && (
                <InputAdornment position="end">
                  <IconButton onClick={() => handleNicknameChange({ target: { value: "" } })} edge="end" size="small">
                    <CloseIcon fontSize="small" sx={{ color: "#8B8B8B" }} />
                  </IconButton>
                </InputAdornment>
              )
            }
          />
        </Grid>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="main-grid-item">
          <Typography className="select-header-create">Client Name</Typography>

          <FormControl>
            <Autocomplete
              selectOnFocus={false}
              open={openMenu}
              onOpen={() => {
                setOpenMenu(true);
                fetchClientSuggestions("");
              }}
              onClose={() => setOpenMenu(false)}
              options={clientList}
              noOptionsText="No clients found"
              loading={loading}
              loadingText="Loading clients..."
              value={selected}
              getOptionLabel={(option) => option.clientName || ""}
              filterOptions={(options) => options}
              isOptionEqualToValue={(option, value) => {
                if (!option || !value) return false;
                return option.clientCode === value.clientCode; // compare by id only
              }}
              // onInputChange={(event, newInputValue) => {
              //   console.log("onInputChange");

              //   setOpenMenu(true);
              //   debouncedFetchClientSuggestions(newInputValue.trim() === "" ? "a" : newInputValue); // To show default list
              // }}
              onInputChange={(event, newInputValue, reason) => {
                if (reason === "input") {
                  setOpenMenu(true);
                  debouncedFetchClientSuggestions(newInputValue.trim() === "" ? "a" : newInputValue);
                }
              }}
              onChange={(event, newValue) => {
                setSelected(newValue);
                if (inputRef.current) {
                  inputRef.current.blur();
                }
              }}
              popupIcon={null} // hide default arrow
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputRef={inputRef}
                  placeholder="Select client name"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <InputAdornment position="end">
                        <Arrow
                          onClick={(e) => {
                            e.stopPropagation(); // prevent textfield focus stealing
                            setOpenMenu((prev) => {
                              const next = !prev;
                              if (next) {
                                fetchClientSuggestions(""); // fetch only when opening
                              }
                              return next;
                            });
                            if (inputRef.current) {
                              inputRef.current.focus();
                            }
                          }}
                          style={{
                            transform: openMenu ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.3s ease",
                            cursor: "pointer",
                          }}
                        />
                      </InputAdornment>
                    ),
                  }}
                  onFocus={(e) => {
                    const input = e.target;
                    requestAnimationFrame(() => {
                      input.setSelectionRange(input.value.length, input.value.length); // move cursor to end
                    });
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0.3vw",
                      border: "0.1vw solid #000",
                      fontFamily: "karla !important",
                      fontSize: "1.1vw !important",
                      fontWeight: "500 !important",
                      paddingRight: "0.5vw !important",
                      outline: "none !important",
                      height: "6.89vh",
                      "&.Mui-focused": {
                        border: "0.1vw solid #000 !important",
                        boxShadow: "none !important",
                        outline: "none !important",
                      },

                      "& fieldset": {
                        border: "none",
                      },
                      "&:hover fieldset": {
                        border: "none",
                      },
                      "&.Mui-focused fieldset": {
                        border: "none",
                      },
                    },

                    "& input": {
                      fontFamily: "karla !important",
                      fontSize: "1.1vw !important",
                      fontWeight: "500 !important",
                      color: "black",
                      outline: "none !important",
                      cursor: "pointer !important",
                    },
                  }}
                />
              )}
              sx={{ width: "22.5vw !important" }}
              PopperComponent={(props) => (
                <Popper
                  {...props}
                  style={{
                    width: "22.499vw", // same vw as input
                  }}
                  modifiers={[
                    {
                      name: "offset",
                      options: {
                        offset: [0, 6],
                      },
                    },
                  ]}
                />
              )}
              PaperComponent={(props) => (
                <Paper
                  {...props}
                  sx={{
                    backgroundColor: "#fff",
                    color: "#000 !important",
                    borderRadius: "0.3vw",
                    border: "1px solid #fff",
                    "& .MuiAutocomplete-option": {
                      fontSize: "1.1vw",
                      fontFamily: "karla",
                      fontWeight: 400,
                      color: "#000",
                      backgroundColor: "#fff !important", // base bg
                      marginBottom: "0.2vw",
                      "&:hover": {
                        backgroundColor: "#f2f2f2 !important", // hover color
                      },
                      '&[aria-selected="true"]': {
                        backgroundColor: "#848484ff !important", // selected option
                      },
                    },
                    "& .MuiAutocomplete-noOptions": {
                      fontSize: "1.1vw",
                      fontFamily: "karla",
                      color: "#000",
                      padding: "0.5rem 1rem",
                    },
                    "& .MuiAutocomplete-loading": {
                      fontSize: "1.1vw",
                      fontFamily: "karla",
                      color: "#000",
                      padding: "0.5rem 1rem",
                    },
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="main-grid-item">
          <Typography className="select-header-create">Due Date</Typography>
          <OutlinedInput
            value={selectedDate ? formatDate(selectedDate) : formatDate(new Date())}
            onClick={toggleCalendar}
            readOnly
            className="input-field"
            inputProps={{
              placeholder: "Select due date",
            }}
            sx={{
              "& .MuiOutlinedInput-input": {
                cursor: "pointer !important",
              },
            }}
          />
        </Grid>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="main-grid-item">
          <div style={{ position: "relative", marginBottom: "16px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography className="select-header-create">Comments</Typography>
            <IconButton
              style={{
                height: "35px",
                width: "35px",
                borderRadius: "50%",
                backgroundColor: "#000000ff",
                color: "#fff",
              }}
              onClick={handleMicClick}
            >
               <MicIcon />
            </IconButton>
          </div>

          <textarea
            placeholder="Enter your message"
            value={comment}
            onChange={(e) => handleCommentSave(e)}
            className="comment-box"
            style={{
              width: "100%",
              // Keep your original background color - remove the white background
              // background: "#ffffffff",  // REMOVE THIS LINE
              borderRadius: 8,
              padding: 10,
              resize: "none",
              outline: "none",
              fontSize: "16px",
              fontFamily: "Poppins",
              fontWeight: 500,
              minHeight: "100px",
            }}
          />

          {startRecording && (
            <CommentComp
              ref={commentRef}
              isFileUpload={false}
              setStartRecording={setStartRecording}
              setRecordedData={setRecordedData}
              setRecordedBlobData={setRecordedBlobData}
              setAudioPlayer={setAudioPlayer}
              mode="audio"
            />
          )}

          {showAudioPlayer && <AudioPlayer src={recordedData} />}
        </Grid>

        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="main-grid-item">
          <Button
            variant="contained"
            onClick={handleSave}
            sx={{
              backgroundColor: saveChange ? "#50C878" : "#444444",
              "&:hover": {
                backgroundColor: saveChange ? "#50C878" : "#444444",
              },
              width: "100%",
              height: "8.5vh",
              borderRadius: "5px",
              fontWeight: "500 !important",
              fontFamily: "poppins",
              fontSize: "1.1vw",
              textTransform: "none",
            }}
          >
            Create Project
          </Button>
        </Grid>
      </Grid>
      <CalenderComp open={showCalendar} handleClose={closeCalender} onDateSelect={handleDateSelect} disableRestrictedDates={true} isCreateProject={true} />
    </Modal>
  );
}

export default CreateProjectDetailsModal;
